import React, { useState } from 'react';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { auth } from '../firebase';

const googleProvider = new GoogleAuthProvider();

const LoginPage = () => {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleGoogle = async () => {
    setBusy(true);
    setError('');
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (err: any) {
      setError(err?.message || 'sign-in failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f7f7f7',
        px: 2,
        fontFamily: '"Quicksand", "Roboto", sans-serif',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          maxWidth: 400,
          width: '100%',
          border: '1px solid #e5e7eb',
          borderRadius: 1,
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography
            variant="h5"
            sx={{
              fontFamily: '"Quicksand", "Roboto", sans-serif',
              fontWeight: 600,
              letterSpacing: '0.02em',
              color: '#1f2937',
            }}
          >
            The Back Room™
          </Typography>
          <Typography
            variant="overline"
            sx={{ color: '#64748b', letterSpacing: '0.25em', fontWeight: 500 }}
          >
            Admin
          </Typography>
        </Box>

        <Stack spacing={2}>
          <Button
            variant="outlined"
            onClick={handleGoogle}
            disabled={busy}
            fullWidth
            sx={{ textTransform: 'none', py: 1 }}
          >
            Continue with Google
          </Button>

          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </Paper>
    </Box>
  );
};

export default LoginPage;
